import { useState } from 'react';

export function useSubscriberControls({ pinned, entity, onPin, id }) {
  const [hasAudio, setAudio] = useState(true);
  const [hasVideo, setVideo] = useState(true);
  const audioIcon = hasAudio ? 'sound-on' : 'mute';
  const videoIcon = hasVideo ? 'video-on' : 'video-off';
  const pinIcon = !pinned ? 'pin' : 'unpin';

  const handleAudioToggle = e => {
    e.stopPropagation();
    if (entity) {
      entity.subscribeToAudio(!hasAudio);
      setAudio(!hasAudio);
    }
  };

  const handleVideoToggle = e => {
    e.stopPropagation();
    if (entity) {
      entity.subscribeToVideo(!hasVideo);
      setVideo(!hasVideo);
    }
  };

  const handlePinToggle = e => {
    e.stopPropagation();
    onPin({ id });
  };

  return {
    handleVideoToggle,
    handleAudioToggle,
    handlePinToggle,
    audioIcon,
    videoIcon,
    pinIcon,
    hasAudio,
    hasVideo,
  };
}



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/utils/useSubscriberControls.js